import { Injectable } from '@angular/core';
import { InvoicesService as ApiInvoicesService } from '@ducat-pro-payments/swag-payments';

import { createApi } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class InvoicesService extends createApi(ApiInvoicesService) {}
